module.exports = __webpack_public_path__ + "img/contracts.45ff50d0.svg";